<template>
  <div
    class="hm-age-assignment"
    :class="{ 'hm-age-assignment--active': isActive, 'hm-age-assignment--simple': simple }"
    @click="select"
  >
    <div v-if="counts.adult" class="hm-age-assignment__item">
      <span class="hm-age-assignment__count hm-age-assignment__count--adult">{{ counts.adult }}</span>
      <img class="hm-age-assignment__icon" src="@/assets/img/hm/adult-green.svg" alt="">
    </div>

    <div v-if="counts.teenager" class="hm-age-assignment__item">
      <span class="hm-age-assignment__count hm-age-assignment__count--teenager">{{ counts.teenager }}</span>
      <img class="hm-age-assignment__icon" src="@/assets/img/hm/teenager-blue.svg" alt="">
    </div>

    <div v-if="counts.child" class="hm-age-assignment__item">
      <span class="hm-age-assignment__count hm-age-assignment__count--child">{{ counts.child }}</span>
      <img class="hm-age-assignment__icon" src="@/assets/img/hm/child-pink.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMAgeAssignment',
  props: {
    value: { type: Object, default: null },
    accomodationType: { type: Object, required: true },
    simple: { type: Boolean, default: false },
  },
  computed: {
    counts () {
      const a = (this.accomodationType && this.accomodationType.age_assignment) || {}
      return {
        adult: Number(a.adult) || 0,
        teenager: Number(a.teenager) || 0,
        child: Number(a.child) || 0
      }
    },
    isActive () {
      return this.value === this.accomodationType
    }
  },
  methods: {
    select () {
      this.$emit('input', this.accomodationType)
      this.$emit('change', this.accomodationType)
    }
  }
}
</script>

<style scoped>
.hm-age-assignment {
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: max-content;
  min-width: 58px;
  height: 40px;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #ECEAE5;
  background: #FCFCFC;
  box-shadow: 0 1px 5px 0 rgba(159, 167, 177, 0.20);
  cursor: pointer;
}

.hm-age-assignment--simple {
  min-width: auto;
  height: auto;
  padding: 0;
  border: none;
}

.hm-age-assignment--active {
  border: 1px solid #a3a3a3;
}

.hm-age-assignment__item {
  width: 42px;
  height: 24px;
  border-radius: 6px;
  background: #F6F6F6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.hm-age-assignment__count {
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
}

.hm-age-assignment__count--adult {
  color: #9AB992;
}

.hm-age-assignment__count--teenager {
  color: #76A9B4;
}

.hm-age-assignment__count--child {
  color: #D493B0;
}

.hm-age-assignment__icon {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
}
</style>
